import * as React from 'react'

import { OgImageBlock } from '@basehub/data/replicache/index'
import {
  CopyIcon,
  LayersIcon,
  StackIcon,
  TrashIcon,
} from '@radix-ui/react-icons'
import { OgImageBlockLayerType } from '~/app/(dash)/[team-slug]/(repo)/[repo-slug]/(editor)/explore/components/blocks/og-image/types'
import { LayerFunctions } from '~/app/(dash)/[team-slug]/(repo)/[repo-slug]/(editor)/explore/components/blocks/og-image/utils'
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuLabel,
  ContextMenuSeparator,
  ContextMenuTrigger,
} from '~/sotano-kit/primitives/context-menu'

export function OgImageLayerContextMenuWrapper({
  layerFunctions,
  children,
  layer,
  block,
}: {
  layerFunctions: LayerFunctions
  children: React.ReactNode
  layer: OgImageBlockLayerType
  block: OgImageBlock
  path: string
}) {
  const triggerRef = React.useRef<HTMLDivElement>(null)

  return (
    <ContextMenu>
      <ContextMenuTrigger ref={triggerRef}>{children}</ContextMenuTrigger>
      <ContextMenuContent>
        <ContextMenuLabel>
          <span className="text-dark-muted">Editing layer of </span>
          {block.title}
        </ContextMenuLabel>
        <ContextMenuItem
          className="space-x-2 text-xs leading-4"
          onClick={async () => {
            await layerFunctions.addLayer(layer)
          }}
        >
          <CopyIcon width={16} height={16} />
          <span>Duplicate</span>
        </ContextMenuItem>

        <ContextMenuSeparator />

        <ContextMenuItem
          className="space-x-2 text-xs leading-4"
          onClick={async () => {
            await layerFunctions.bringToFront(layer)
          }}
          disabled={!layerFunctions.canBring(layer)}
        >
          <LayersIcon width={16} height={16} />
          <span>Bring to front</span>
        </ContextMenuItem>
        <ContextMenuItem
          className="space-x-2 text-xs leading-4"
          onClick={async () => {
            await layerFunctions.bringForward(layer)
          }}
          disabled={!layerFunctions.canBring(layer)}
        >
          <StackIcon width={16} height={16} />
          <span>Bring forward</span>
        </ContextMenuItem>
        <ContextMenuItem
          className="space-x-2 text-xs leading-4"
          onClick={async () => {
            await layerFunctions.sendBackward(layer)
          }}
          disabled={!layerFunctions.canSend(layer)}
        >
          <StackIcon width={16} height={16} />
          <span>Send backward</span>
        </ContextMenuItem>
        <ContextMenuItem
          className="space-x-2 text-xs leading-4"
          onClick={async () => {
            await layerFunctions.sendToBack(layer)
          }}
          disabled={!layerFunctions.canSend(layer)}
        >
          <LayersIcon width={16} height={16} />
          <span>Send to back</span>
        </ContextMenuItem>

        <ContextMenuSeparator />

        <ContextMenuItem
          className="space-x-2 text-xs leading-4"
          onClick={() => {
            layerFunctions.removeLayer(layer)
          }}
        >
          <TrashIcon width={16} height={16} />
          <span>Delete</span>
        </ContextMenuItem>
      </ContextMenuContent>
    </ContextMenu>
  )
}
